import React, { useState } from 'react';
import Button from 'components/shared/Button';
import s from './Checkout.module.scss';
import useGetPromocodes from 'sdk/hooks/shop/useGetPromocodes';
import useIsAuth from 'sdk/hooks/useIsAuth';

const Promocode = ({ cartItems, onApplyDiscount }) => {
  const [promoInput, setPromoInput] = useState('');
  const [error, setError] = useState('');
  const { data: isAuthData } = useIsAuth();
  const userId = isAuthData?.user?.id;
  const { data: promocodes } = useGetPromocodes(userId, 'product');
  
  console.log('Promocodes:', promocodes,userId);
  const handleApply = () => {
    if (!promoInput.trim()) return;

    const matchingPromo = promocodes?.find(
      (promo) => promo.promocode.toLowerCase() === promoInput.toLowerCase()
    );

    if (!matchingPromo) {
      setError('The promocode wont find');
      return;
    }

    let isApplied = false;

    const updatedItems = cartItems.map((item) => {
   
      if (item.product?.id === matchingPromo.product) {
        console.log("Item:", item, "Price:", item.price, "Promo %:", matchingPromo.percent);

        const discount = (item.price * matchingPromo.percent) / 100;
        isApplied = true;
        return {
          ...item,
          discountedPrice: item.price - discount,
          appliedPromocode: matchingPromo.promocode,
        };
      }
      return item;
    });

    if (!isApplied) {
      setError('The promo code does not match any product in the cart');
      return;
    }

    setError('');
    onApplyDiscount(updatedItems);
  };

  React.useEffect(() => {
    setError("")
  }, [promoInput])

  return (
    <div>
      <div className={`${s.promocode} ${error ? s.promocodeError : undefined}`}>
        <input
          className={s.promocode_field}
          type="text"
          placeholder="PROMO CODE"
          value={promoInput}
          onChange={(e) => setPromoInput(e.target.value)}
        />
        <Button secondarySmall yellow onClick={handleApply}>
          APPLY
        </Button>
      </div>
      {error && <div className={s.promocodeErrorText}>{error}</div>}
    </div>
  );
};

export default Promocode;
